import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { IWatchlistable } from 'src/components/filmwebid/withWatchlistState';
import WatchlistSvg from 'src/components/svg/WatchlistSvg';
import styles from './WatchlistActionButton.module.css';
import { locale } from "@locale";

//#region [Props]
type WatchlistActionButtonProps = {
  className?: string;
  hideLabel?: boolean;
  dkVariant?: "light" | "dark";
} & IWatchlistable;
//#endregion

//#region [Component]
export default function WatchlistActionButton(t0) {
  const $ = _c(12);
  const {
    className,
    isWatchlisted,
    onWatchlistClick,
    hideLabel: t1,
    dkVariant
  } = t0;
  const hideLabel = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className || $[1] !== dkVariant) {
    const themeStyles = process.env.NEXT_PUBLIC_WEBSITE_BRAND === "kinodk" ? {
      "themedk": true,
      [styles.ThemeDk]: true,
      [styles.Variant_Light]: dkVariant === "light",
      [styles.Variant_Dark]: dkVariant === "dark"
    } : {
      "themefk": true,
      [styles.ThemeFk]: true
    };
    t2 = classNames(styles.SButton, className, themeStyles);
    $[0] = className;
    $[1] = dkVariant;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isWatchlisted) {
    t3 = <WatchlistSvg className={styles.SWatchlistSvg} selected={isWatchlisted} />;
    $[3] = isWatchlisted;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== hideLabel) {
    t4 = !hideLabel && <span className={styles.SWatchListLabel}>Watchlist</span>;
    $[5] = hideLabel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onWatchlistClick || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <button className={t2} onClick={onWatchlistClick} title={locale.watchlist.addToWatchlist}>{t3} {t4}</button>;
    $[7] = onWatchlistClick;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
//#endregion

//#region [Styles]
// styles migrated to WatchlistActionButton.module.css
//#endregion